/** @format */

import React from "react";
import "./LandingPage.css";

export default function LandingPage({ type, iosUrl, androidUrl }) {
  return (
    <div className="landingContainer">
      <div className="landingLabel">[{type} HC]</div>
      <div className="contentWrapper">
        <div className="squirrelContainer">
          <img
            src="/images/squirrel.png"
            alt="YouROK Mascot"
            className="squirrelImg"
          />
        </div>

        <div className="rightColumn">
          <img src="/images/logo1.png" alt="YouROK Logo" className="logoImg" />

          <hr className="divider" />

          <div className="linksContainer">
            <a href={iosUrl} className="downloadLink">
              iOS
            </a>
            <a href={androidUrl} className="downloadLink">
              Android
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
